var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.002,
    height: 24.002,
    viewBox: "0 0 24.002 24.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69736",
    transform: "translate(-6.428 -3.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58476",
    d: "M18.429,27.431a12,12,0,1,0-12-12A12,12,0,0,0,18.429,27.431Z",
    fill: "#1891e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58477",
    d: "M23.382,14.149h1.355A1.142,1.142,0,0,1,25.867,15.3v5.162a1.142,1.142,0,0,1-1.129,1.147H15.7a1.142,1.142,0,0,1-1.13-1.147V15.3a1.142,1.142,0,0,1,1.13-1.147h1.355a.5.5,0,0,0,.446-.326l.35-1.068a.5.5,0,0,1,.446-.326h3.84a.5.5,0,0,1,.446.326l.35,1.068A.5.5,0,0,0,23.382,14.149Zm-4.857,3.441a1.694,1.694,0,1,1,1.694,1.721A1.708,1.708,0,0,1,18.525,17.591Zm1.694,2.868a2.868,2.868,0,1,1,2.824-2.868A2.846,2.846,0,0,1,20.219,20.459ZM23.946,15.7a.4.4,0,1,0,.4-.4A.4.4,0,0,0,23.946,15.7Z",
    transform: "translate(-1.436 -1.588)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera2);
export default __webpack_public_path__ + "static/media/camera2.9fc49247.svg";
export { ForwardRef as ReactComponent };